import React from 'react';
import Reveal from '../ui/Reveal';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Contact = () => {
  return (
    <section id="contact" className="py-24 md:py-32 bg-navy-900 text-white border-t border-navy-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          
          {/* Left: Info */}
          <Reveal direction="right">
            <div>
              <h2 className="font-serif text-5xl md:text-6xl mb-6 leading-tight">
                Ready to Own <br/><span className="text-gold-500 italic">Your Narrative?</span>
              </h2>
              <p className="text-gray-400 text-lg font-light mb-12 max-w-md">
                Whether you're looking to redefine your brand or secure top-tier media placement, let's craft a story that demands attention.
              </p>

              <div className="space-y-6">
                <a 
                  href="mailto:hello@page1news.com" 
                  className="flex items-center space-x-4 text-gray-300 hover:text-gold-500 transition-colors group"
                >
                  <div className="w-12 h-12 border border-gray-700 rounded-full flex items-center justify-center group-hover:border-gold-500 transition-colors">
                    <SafeIcon icon={FiIcons.FiMail} />
                  </div>
                  <span className="text-lg font-light tracking-wide">hello@page1news.com</span>
                </a>

                <a 
                  href="tel:+919811935511" 
                  className="flex items-center space-x-4 text-gray-300 hover:text-gold-500 transition-colors group"
                >
                  <div className="w-12 h-12 border border-gray-700 rounded-full flex items-center justify-center group-hover:border-gold-500 transition-colors">
                    <SafeIcon icon={FiIcons.FiPhone} />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs uppercase tracking-widest text-gray-500 mb-0.5">Call Us</span>
                    <span className="text-lg font-medium tracking-wider">+91 98119 35511</span>
                  </div>
                </a>
              </div>
            </div>
          </Reveal>

          {/* Right: Form */}
          <Reveal direction="left" delay={0.2}>
            <form className="bg-navy-800 p-8 md:p-10 border border-gray-700 rounded-sm">
              <div className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-xs uppercase tracking-widest text-gray-400 mb-2">Name</label>
                  <input 
                    type="text" 
                    id="name" 
                    className="w-full bg-transparent border-b border-gray-600 py-3 text-white focus:outline-none focus:border-gold-500 transition-colors" 
                    placeholder="John Doe" 
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-xs uppercase tracking-widest text-gray-400 mb-2">Email</label>
                  <input 
                    type="email" 
                    id="email" 
                    className="w-full bg-transparent border-b border-gray-600 py-3 text-white focus:outline-none focus:border-gold-500 transition-colors" 
                    placeholder="john@company.com" 
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block text-xs uppercase tracking-widest text-gray-400 mb-2">Your Story Needs...</label>
                  <textarea 
                    id="message" 
                    rows="4" 
                    className="w-full bg-transparent border-b border-gray-600 py-3 text-white focus:outline-none focus:border-gold-500 transition-colors resize-none" 
                    placeholder="Tell us briefly about your goals." 
                  ></textarea>
                </div>
                <button 
                  type="button" 
                  className="w-full bg-gold-500 text-navy-900 py-4 uppercase tracking-widest text-sm font-semibold hover:bg-white transition-colors duration-300 mt-4"
                >
                  Submit Inquiry
                </button>
              </div>
            </form>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Contact;